import { Controller } from "stimulus";

// Spec: docs/specs/2026-10-05-shp-18956-issue-bl-before-departure.md
// Keeps the "issue BL before departure" modal open and locked while the
// publish request (PDF generation + upload) is running, so the operator gets
// immediate feedback instead of a silent wait.
export default class extends Controller {
  static targets = ["dismiss", "hint"];

  connect() {
    this.isBusy = false;
    this.preventHideWhileBusy = this.preventHideWhileBusy.bind(this);
    $(this.element).on("hide.bs.modal", this.preventHideWhileBusy);
  }

  disconnect() {
    $(this.element).off("hide.bs.modal", this.preventHideWhileBusy);
  }

  busy() {
    this.isBusy = true;
    this.element.setAttribute("aria-busy", "true");
    this.dismissTargets.forEach((button) => {
      button.disabled = true;
    });
    this.hintTarget.classList.remove("d-none");
  }

  preventHideWhileBusy(event) {
    if (this.isBusy) {
      event.preventDefault();
    }
  }
}
